import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Appbar from '../component/Appbar2'
import { useDispatch, useSelector } from 'react-redux'
import Points from '../../../../assets/icon/points.png'
import moment from 'moment'
import Coin from '../../../../assets/theme6/coin.svg'
import VoucherSvg from '../../../../assets/svg/VoucherSvg'
import Style from '../Profile/profile.module.scss'
import AvatarModal from './AvatarModal'
import Boy from '../../../../assets/theme6/boy.svg'
import Girl from '../../../../assets/theme6/girl.svg'
import Edit from '../../../../assets/theme6/profile_edit.svg'
import Mail from '../../../../assets/theme6/mail.svg'
import IBTN from '../../../../assets/theme6/i_btn.svg'
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { getUserQuizAction } from '../../../../redux/user/getUserQuzHistory'
import BottomBar from '../component/BottomBar'
import BigArrow from '../../../../assets/svg/BigArrow'

export default function Profile() {
    // state
    window.scrollTo(0, 0);

    const [isAvatarModal, setIsAvatarModal] = useState(false);
    const [isInfo, setIsInfo] = useState(false);
    const [isSpentInfo, setIsSpentInfo] = useState(false);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(5);
    const [transactionData, setTransactionData] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const dispatch = useDispatch()

    const getUserDetails = useSelector(state => state.getUserDetails)
    const { data: userData, status, message } = getUserDetails

    const getUserQuiz = useSelector(state => state.getUserQuiz)
    const { data: TransactionData, loading } = getUserQuiz
    const getAppData = useSelector(state => state.getApp)
    const { data: appData } = getAppData
    const [userScreenWidth, setUserScreenWidth] = useState()
    const navigation = useNavigate()

    useEffect(() => {
        if (page == 0) {
            setTransactionData(prev => [...TransactionData]);
            setHasMore(TransactionData.length >= limit);
        } else if (TransactionData && Array.isArray(TransactionData)) {
            setTransactionData(prev => [...prev, ...TransactionData]);
            setHasMore(TransactionData.length >= limit);
        }
    }, [TransactionData]);

    useEffect(() => {
        dispatch(getUserQuizAction({ page: page, limit: limit }))
        setUserScreenWidth(window.innerWidth)
        //    if (TransactionData && Array.isArray(TransactionData)) {
        // setTransactionData(prev => [...prev, ...TransactionData]);
        // setHasMore(TransactionData.length >= limit);
        // }
    }, [page])

    const openAvatar = () => {

        setIsAvatarModal(true)
    }

    function getEmail(email) {
        try {
            if (email?.length <= 25) {

                return userData?.email
            } else {

                let fontSize = 8;
                let remainScreenSize = userScreenWidth - 320;
                let charCanAdjust = Math.floor(remainScreenSize / fontSize);
                if (email.length < email.substring(0, 25) + charCanAdjust) {
                    return email.substring(0, 25 + charCanAdjust)
                }
                return email.substring(0, 25 + charCanAdjust - 3) + '...'
            }

        } catch (error) {
            console.log(error, "error")
        }


    }


    return (
        <>


            <div className={Style.newBackgroundImage}>
                <Appbar />

                <div className={Style.main_div}>

                    <div className={Style.container}>

                        <div className={Style.details__Area}>


                            <div className={Style.quizHeader}>

                                <div className={[Style.quizInfo, Style.mt20]} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                    <div className={Style.quizImage} >
                                        {userData?.avatar_type &&
                                            <img src={userData?.avatar_type == 1 ? Boy : Girl} width="100%" height="100%" alt="food" />
                                        }
                                    </div>

                                    <div onClick={openAvatar} style={{ border: "2px solid greens", position: "relative", background: "#FA5743", width: "25px", height: "25px", left: "50px", bottom: "35px", zIndex: "111", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}>
                                        <img src={Edit} width={"21px"} alt="edit_btn" s />
                                    </div>
                                    <div className={Style.quizdesc}>
                                        {/* <h4 className={Style.quizName}>{userData?.email?.charAt(0).toUpperCase()}</h4> */}
                                        <h5 className={Style.catName}>{userData?.name ? userData?.name : "---"}</h5>

                                    </div>
                                </div>
                                <div className={Style.box_earn}>
                                    <div className={Style.earn}>
                                        {
                                            isInfo ? <div className={Style.info} onClick={() => { setIsInfo(false) }}><div><img className={Style.nestedibtn} onClick={() => { setIsInfo(true) }} src={IBTN} alt="i_btn" /><p>Your Total <br /> wallet</p></div></div> : <img className={Style.ibtn} onClick={() => { setIsInfo(true) }} src={IBTN} alt="i_btn" />
                                        }
                                        <div >
                                            <div className={Style.coin}><img src={Coin} /><p>{userData?.totalCoins ? userData?.totalCoins.toFixed(0) : "---"}</p></div>
                                            <div className={Style.coinsEarned}><p>Wallet</p></div>
                                        </div>

                                    </div>

                                    <div className={Style.earn}>
                                        {
                                            isSpentInfo ? <div className={Style.info} onClick={() => { setIsSpentInfo(false) }}><div><img className={Style.nestedibtn} onClick={() => { setIsSpentInfo(true) }} src={IBTN} alt="i_btn" /><p>Your Total <br /> withdrawals</p></div></div> : <img className={Style.ibtn} onClick={() => { setIsSpentInfo(true) }} src={IBTN} alt="i_btn" />
                                        }
                                        <div>
                                            <div className={Style.coin}><img src={Coin} /><p>{userData?.withdrawal ? userData?.withdrawal.toFixed(0) : "---"}</p></div>
                                            <div className={Style.coinsEarned}><p>Coins Spent</p></div>
                                        </div>

                                    </div>
                                </div>


                            </div>


                            <div className={Style.profile_cover}>
                                <div className={Style.profile__detail__section}>
                                    <div className={Style.email}>
                                        <div className={Style.logo}><img src={Mail} alt="mail" /></div>
                                        {userData?.email && <div className={Style.content} id='emailDiv'>Email:&nbsp;{getEmail(userData.email)}</div>}

                                    </div>

                                    {/* <div className={Style.number} onClick={() => navigation("/myVouchers")}>
                                        <div className={Style.logo}><VoucherSvg /></div>
                                        <div className={Style.content}>My Gift Cards</div>
                                        <div className={Style.bigArrowMargin}>
                                            <BigArrow />
                                        </div>

                                    </div> */}
                                </div>



                                <div className={Style.history__heading}>
                                    <h3>History</h3>
                                    <div className={Style.view_all}>
                                        <p><Link className={Style.link} to={'/history'}>View all</Link></p>
                                    </div>

                                </div>
                                <div className={Style.historyCover}>



                                    {loading ? <Box sx={{ width: "95%" }}>

                                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                                        <br />
                                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                                        <br />
                                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                                        <br />
                                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />


                                    </Box> : transactionData.length > 0 ? transactionData.map((item, index) => (

                                        (
                                            <div className={Style.history__card} key={index}>
                                                <div className={Style.history__pic}>
                                                    <img src={item?.challenge_id?.image} alt="icon" />
                                                </div>
                                                <div className={Style.history__details}>
                                                    <div className={Style.top}>
                                                        <div className={Style.name}>{(item?.challenge_id?.challenge_name.length > 11 && userScreenWidth < 360) ? item?.challenge_id?.challenge_name.substring(0, 11) + "..." : (item?.challenge_id?.challenge_name.length > 14 && userScreenWidth < 420) ? item?.challenge_id?.challenge_name.substring(0, 14) + "..." : item?.challenge_id?.challenge_name.substring(0, 18)}</div>
                                                    </div>
                                                    <div className={Style.middle}>{item?.challenge_id?.cat_id?.cat_name ? item?.challenge_id?.cat_id?.cat_name : 'Daily Reward'}</div>

                                                    <div className={Style.bottom}>
                                                        <div>
                                                            Completed On&nbsp;{moment.utc(item.createdAt).local().format("Do MMM YY")}
                                                        </div>
                                                        <div>
                                                            |
                                                        </div>
                                                        <div>
                                                            {moment.utc(item.createdAt).local().format('h:mm a')}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={Style.logo}>
                                                    <div className={Style.logo_pic}>
                                                        <img src={Points} alt="logo" />
                                                    </div>
                                                    <p className={Style.reward_pic}>{item?.reward.toPrecision(4)}</p>
                                                </div>


                                            </div>
                                        ))
                                    ) : <div className={Style.no__transaction}><h3>No history available</h3></div>}
                                    {hasMore && <div className={Style.loadmore_box} onClick={() => setPage(page + 1)}>Load More</div>}
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


                <BottomBar />
                {isAvatarModal && <AvatarModal isAvatarModal={isAvatarModal} setIsAvatarModal={setIsAvatarModal} avatar_type={userData?.avatar_type} />}
            </div>

        </>

    )
}
